var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-combobox",
    _vm._g(
      _vm._b(
        {
          attrs: { value: _vm.value, box: "", "hide-details": "" },
          on: { input: (val) => _vm.$emit("input", val) },
        },
        "v-combobox",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }